let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  data: [],
  template: require('views/templates/accueil'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click #tabs-accueil .nav-link': 'changeTabs',
      'click .btn-add-cart': 'add2Cart'
    })
  },
  afterRender () {
    this.rendered = true // Important pour que le routeur sache facilement que le home est déjà rendu

    app.ajax({
      url: '/sport',
      complete: app.onComplete({
        success: (data) => {
          $('#tabs-accueil').append(require('views/templates/accueil-tabs')({ data }))
          data.forEach((obj) => {
            $('#tab-pane-accueil').append('<div role="tabpanel" class="tab-pane fade pad-no" id="section-' + obj.id_sport + '"></div>')
          })
        },
        complete: () => {
          this.delegateEvents()
        }
      })
    })

    this.listConseils()
    app.initTooltip()
  },
  listConseils () {
    // let data = $('#form-pagination').serialize()

    $('#accueil-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

    let data = 'fromNow=1&all=1&filter-actif=1'

    let search = $('#global-search-form').serialize()
    if (search) data += '&' + search

    let filters = $('#global-filter-form').serialize()
    if (filters) data += '&' + filters

    app.ajax({
      url: '/conseil',
      data,
      success: (...args) => this.refreshList(...args)
    })
  },
  refreshList (conseils, status, xhr) {
    if (conseils && conseils.length) {
      let data = {}
      this.data = conseils
      conseils.sort((a, b) => moment(a.dateEvent) > moment(b.dateEvent))

      conseils.forEach((obj) => {
        let d = moment(obj.dateEvent, 'YYYY-MM-DD HH:II:SS').format('YYYY-MM-DD')
        if (!data[d]) data[d] = []
        data[d].push(obj)
      })

      let cart = app.getCart()
      let conseilInCart = cart.products.map((obj) => obj.id_conseil)

      let activeTab = $('#tabs-accueil .nav-item.active .nav-link').data('id')
      if (!activeTab || activeTab === 'tous') {
        $('#tab-pane-accueil > #section-tous').empty().html(require('views/templates/accueil-list')({
          data,
          logged: this.session.logged,
          id_user_logged: this.session.user ? this.session.user.id_user : null,
          conseilInCart,
          searchTerms: xhr.getResponseHeader('ps-search-term'),
          total: xhr.getResponseHeader('ps-total-row')
        })).show()
      } else {
        this.changeTabs(activeTab)
      }
      app.initList()
    } else {
      app.noResults('#tab-pane-accueil > #section-tous')
    }
  },
  changeTabs (e) {
    if (this.data && this.data.length) {
      $('#tab-pane-accueil > .tab-pane').hide()
      let idSport = isNaN(e) ? $(e.currentTarget).data('id') : e

      let conseils
      if (idSport !== 'tous') {
        conseils = this.data.filter((o) => o.id_sport == idSport)
      } else {
        conseils = this.data
      }

      let data = {}
      conseils.forEach((obj) => {
        let d = moment(obj.dateEvent, 'YYYY-MM-DD HH:II:SS').format('YYYY-MM-DD')
        if (!data[d]) data[d] = []
        data[d].push(obj)
      })
      $('#tab-pane-accueil > #section-' + idSport).empty().html(require('views/templates/accueil-list')({
        data,
        logged: this.session.logged
      })).show()
    } else {
      app.noResults('#tab-pane-accueil > #section-' + $(e.currentTarget).data('id'))
    }
  },
  add2Cart (e) {
    let tr = $(e.currentTarget).closest('tr')
    let id = tr.data('id')
    let evenement = tr.find('td.evenement').data('value')
    let details = tr.find('td.pays-sport').data('value')
    let prix = tr.find('td.prix').data('value')
    if (!id) console.warn('Something goes wrong, no ID')

    if (this.session.user.id_user == tr.find('.user-profil').data('id-user')) return false

    let product = {}
    product.quantity = 1
    product.evenement = evenement
    product.details = details
    product.prix = prix
    product.id_conseil = id

    if (localStorage && localStorage.getItem('cart')) {
      let cart = JSON.parse(localStorage.getItem('cart'))
      let alreadyExist = cart.products.find((p) => p.id_conseil === id)

      if (!alreadyExist) {
        cart.products.push(product)
        localStorage.setItem('cart', JSON.stringify(cart))
        $('#cart').empty().html(require('views/templates/top-cart')({
          cart: cart.products,
          cartLength: cart.products.length
        })).show()
        $('#cart .dropdown-toggle').dropdown()

        // On change le bouton
        $(e.currentTarget).removeClass('btn-primary btn-add-cart').addClass('btn-default disabled').html('<span class="fa fa-thumbs-o-up"></span> Dans le panier')
      }
    } else {
      console.warn('Pas de cart de défini dans le localStorage')
    }
  }
})
